import { render, staticRenderFns } from "./hallOfFameGroupsList.vue?vue&type=template&id=5e1e6055&"
import script from "./hallOfFameGroupsList.vue?vue&type=script&lang=js&"
export * from "./hallOfFameGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports